import { UI, HStack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Box, Button } from 'native-base';
import React from 'react';

import {
  StatusSkeleton,
  TextSkeleton,
} from '../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { TableItem } from '../OrderHistoryItem/tablet';

export const OrderHistoryItemLoadingTablet: React.FC = () => {
  return (
    <UI.Shadow
      testId="table-item-tablet"
      level={1}
      marginY={Spacing['stack.nano']}
      borderRadius={BoxBorder.heavy}>
      <VStack py={Spacing['stack.xxxs']} px={Spacing['inline.xxs']}>
        <HStack alignItems="center">
          <HStack space={Spacing['inline.xxxs']} alignItems="center" w="1/4">
            <UI.Icon name="Pdf" size="xs" color="neutral.medium" />
            <TableItem label="ID Ordem" value={<TextSkeleton />} />
          </HStack>
          <HStack space={Spacing['inline.nano']} alignItems="center" w="1/4">
            <TableItem label="ID Cesta" value={<TextSkeleton />} />
          </HStack>
          <HStack w="full" maxW={'1/4'}>
            <TableItem label="Tipo" valueUppercase value={<TextSkeleton />} maxW="160px" />
          </HStack>
          <TableItem label="Data de envio" value={<TextSkeleton />} maxW="1/4" />
        </HStack>
        <Box w="full" h="1px" bgColor={Color['neutral.lightest']} my={Spacing['inline.nano']} />
        <HStack alignItems="center">
          <HStack w="full" maxW={'1/4'}>
            <TableItem label="Cliente" value={<TextSkeleton />} maxW="160px" />
          </HStack>
          <TableItem label="Produto" value={<TextSkeleton />} valueUppercase maxW="1/4" />
          <TableItem label="Valor enviado" value={<TextSkeleton />} maxW="1/4" />
          <HStack w="1/4" justifyContent="space-between" alignItems="center">
            <TableItem label="Status" value={<StatusSkeleton w="full" />} />
            <Button
              color="neutral.medium"
              variant="textLink"
              rightIcon={<UI.Icon name="ArrowRight" size="xxs" color="neutral.medium" />}
            />
          </HStack>
        </HStack>
      </VStack>
    </UI.Shadow>
  );
};
